export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function renderQuestionText(text) {
    try {
        let formattedText = text.replace(/\n/g, '<br />')
        formattedText = formattedText
            .replace(/-\*([^*]+)\*-/g, '<u>$1</u>') // -*text*- for underline
            .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>') // **text** for bold
            .replace(/\*([^*]+)\*/g, '<i>$1</i>') // *text* for italic

        return <div dangerouslySetInnerHTML={{ __html: formattedText }} />
    } catch {
        return <div dangerouslySetInnerHTML={{ __html: text }} />
    }

}

export function renderTextV2(text) {
    let formattedText = text.replace(/\n/g, '<br />')
    formattedText = formattedText
        .replace(/-\*([^*]+)\*-/g, '<u>$1</u>') // -*text*- for underline
        .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>') // **text** for bold
        .replace(/\*([^*]+)\*/g, '<i>$1</i>') // *text* for italic

    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />
}